'use strict';

export class PdfDownloadCtrl {
	downloadName = 'file.pdf';
	reportLoading = false;
	buttonText = "Download PDF";
	downloadUrl = null;
	downloadMimeType = 'application/pdf';
	downloadDefaultName = 'file.pdf';

	constructor($scope, $http, notify) {
		'ngInject';
		this.$scope = $scope;
		this.$http = $http;
		this.notify = notify;
	}

	handleButtonClick(e, url) {
		this.downloadPdf(e, url, true);
	}

	downloadPdf(e, url, save) {
		if (url && url !== '') {
			this.reportLoading = true;
			this.buttonText = "Downloading...";

			this.$http({
				url: url,
				method: 'GET',
				responseType: 'json',
			})
				.then((response) => {
					if (response.data && response.data.success) {
						this.downloadUrl = response.data.download_url;
						this.downloadName = response.data.file_name || this.downloadDefaultName;
						this.downloadMimeType = response.data.mime_type || 'application/pdf';

						this.initiateDownload(this.downloadUrl, this.downloadName, this.downloadMimeType, save);
					} else {
						console.error(response);
					}
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				})
				.finally(() => {
					this.reportLoading = false;
					this.buttonText = "Download PDF";
				});
		}
	}

	initiateDownload(url, filename, mimeType, save) {
		this.$http({
			url: url,
			method: 'GET',
			responseType: 'blob',
		})
			.then((response) => {
				if (response.data) {
					const blob = new Blob([response.data], { type: mimeType });
					const downloadUrl = window.URL.createObjectURL(blob);

					const link = document.createElement('a');
					link.href = downloadUrl;
					link.download = filename;
					link.target = save ? '_self' : '_blank';

					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					window.URL.revokeObjectURL(downloadUrl);
				}
			})
			.catch((error) => {
				console.error("Error downloading PDF:", error);
				this.notify.error("An error occurred while downloading the PDF.");
			});
	}
}
